import Vue from "vue";
import Vuex from "vuex";
import service from "../../services/liquidacion/liquidation";


Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    service: new service(),
    liquidation: [],
    details: [],
    salary: [],
    signature: [],
    headers:[],
    rows:[],
    visibleColumns:{}
 
  },

  mutations: {
    setLiquidation(state, data) {
      state.liquidation = data;
    },
    setDetails(state, data) {
      state.details = data;
    },
    setSalary(state, data) {
      state.salary = data;
    },
    setSignature(state, data) {
      state.signature = data;
    },
    setHeaders(state, data) {
      state.headers = data;
    },
    setRows(state, data) {
      state.rows = data;
    },
    setVisibleColumns(state, { columnName, isVisible }) {
      state.visibleColumns = {
        ...state.visibleColumns,
        [columnName]: isVisible
      };
    },
    setResetVisibleColumns(state) {
      const initialColumns = {};
      state.headers.forEach((header) => {
        initialColumns[header.value] = true;
      });
      state.visibleColumns = { ...initialColumns };
    }
  
  

  },
  actions: {
    async getLiquidation(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getLiquidation();

          state.commit("setLiquidation", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    //open or close liquidation
    async close(state,item) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.changeState(item).then();
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    async open(state,item) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.changeState(item).then();
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
 
    async signature(state,item) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.signature(item).then();
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async removeSignature(state,item) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.removeSignature(item).then();
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async generateSalaryInterface(state,item) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.generateSalaryInterface(item).then();
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async getDetails(state,item) {
      return new Promise(async (resolve, reject) => {
        try {
          let details = await state.state.service.getDetails(item)
          state.commit("setDetails", details);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async getSalary(state,item) {
      return new Promise(async (resolve, reject) => {
        try {
          let salary = await state.state.service.getSalary(item)
          
          state.commit("setSalary", salary);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async getSignature(state,item) {
      return new Promise(async (resolve, reject) => {
        try {
          let signature = await state.state.service.getSignature(item)
          state.commit("setSignature", signature);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
   
   
  },
 
});
